import { supabase } from '../lib/supabase';

export const createPaymentIntent = async ({ amount, currency, recaptchaToken, clientEmail }) => {
  const { data, error } = await supabase.functions.invoke('create-payment-intent', {
    body: { amount, currency, recaptcha_token: recaptchaToken || undefined, client_email: clientEmail },
  });
  if (error || !data?.clientSecret) {
    throw new Error(data?.error || error?.message || 'Could not initialise payment.');
  }
  return data.clientSecret;
};

export const processRefund = async (paymentIntentId) => {
  await supabase.functions.invoke('process-refund', {
    body: { payment_intent_id: paymentIntentId },
  });
};
